import styled from "styled-components/macro";
import TextField from "@material-ui/core/TextField";
import { RadioGroup } from "@material-ui/core";
import { FormikInputMoney } from "@loanbossinc/component-library";

export const PaddedWrapper = styled.div`
  && {
    padding: ${props => props.padding || "0 1em"};
  }
`;

export const Title = styled.div`
  font-family: Work Sans;
  font-size: ${props => props.fontSize || "20px"};
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  padding-top: ${props => props.paddingTop || 0};
  text-align: left;
`;

export const Header = styled.div`
  && {
    align-items: center;
    background: #ffffff;
    border: ${props => !props.isLineItem && "1px solid #dadce0"};
    box-shadow: ${props => !props.isLineItem && "0px 10px 20px rgba(173, 174, 174, 0.25)"};
    box-sizing: border-box;
    display: flex;
    height: 88px;
    justify-content: space-between;
    width: 100%;
    z-index: 2;
  }
`;

export const RowContainer = styled.div`
  && {
    background: #ffffff;
    margin: 1em;
    margin-bottom: ${props => props.mb || 0};
    padding: 0.7em 0;
    box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
    box-sizing: border-box;
    border: 1px solid #dadce0;
  }
`;

export const StyleDateField = styled(TextField)`
  background: #e8e8e8;

  label {
    padding: 8px 18px;
    color: #999999;
  }

  input {
    padding: 10px 12px;
    color: ${props => props.isEmpty && "rgba(0, 0, 0, 0.56);"};
  }
`;

export const SuitesRowContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5em 1em 0.5em 1em;
  height: 60px !important;
  box-sizing: border-box;
  background-color: ${props => props.header && "#fafafa"};
  border-bottom: ${props => props.border};

  :nth-last-child(1) {
    border-bottom: none !important;
  }
`;

export const SuitesRow = styled.div`
  width: ${props => props.w};
  max-width: ${props => props.w};
  text-align: ${props => props.align};
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
`;

export const RentContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5em 1em 0.5em 1em;
  height: 55px !important;
  box-sizing: border-box;
  background-color: ${props => props.header && "#fafafa"};
  border: 1px solid #dadce0;
  border-top: ${props => (props.header ? "1px solid #dadce0" : "none")};
`;

export const ChargeContainer = styled(RentContainer)``;

export const RentRow = styled.div`
  width: ${props => props.w};
  max-width: ${props => props.w};
  text-align: ${props => props.align};
  font-family: Work Sans;
  font-style: normal;
  font-size: 12px;
  line-height: 14px;
  font-weight: ${props => (props.bold ? "600" : "normal")};
`;

export const ChargeRow = styled(RentRow)``;

export const SuiteNumber = styled.div`
  font-family: Roboto Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  display: flex;
  align-items: center;

  & button {
    cursor: pointer;
    background-color: transparent;
    color: #005aa9;
    border: none;
    padding: 0;
    text-align: left;
  }
`;

export const SquareFootage = styled.div`
  font-family: Roboto Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
`;

export const RowText = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  flex-direction: row !important;
`;

export const StyledRentsInput = styled(TextField)`
  width: ${props => (props.width ? props.width : "80%")};
  & div {
    font-size: 12px !important;
    font-family: Work Sans !important;

    input {
      text-align: ${props => props.textAlign};
    }
  }

  & div::before {
    border-bottom: ${props => (props.isError ? "1px solid rgb(217 0 47 / 69%) !important" : "1px solid rgb(0 90 170 / 69%) !important")};
  }

  & div::after {
    border-bottom: ${props => (props.isError ? "2px solid rgb(217 0 47 / 69%) !important" : "2px solid rgb(0 90 170 / 69%) !important")};
  }
`;

export const StyledChargeInput = styled(StyledRentsInput)``;

export const StyledBaseRentInput = styled(FormikInputMoney)`
  width: 75%;
  & div {
    font-size: 12px !important;
    font-family: Work Sans !important;

    input {
      text-align: ${props => props.textAlign};
    }
  }

  & div::before {
    border-bottom: 1px solid rgb(0 90 170 / 69%) !important;
  }

  & div::after {
    border-bottom: 2px solid rgb(0 90 170 / 69%) !important;
  }
`;

export const StyledBaseChargeInput = styled(StyledBaseRentInput)``;

export const StyledHeaderName = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #5f6368;
`;
